import type { FC } from "react";

import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";
import { allTrackers } from "app/services/track/track";

import type { IDomain } from "../../MarketBuilder.types";

import type {
    CellStateType } from "./SelectedDomainsList.styles";
import {
    DomainRowContainer,
    DomainItemContainer,
    DomainItem,
    StyledIconButton
} from "./SelectedDomainsList.styles";

interface ISelectedDomainItem {
    entity: IDomain;
    onDeleteDomain: (domain: IDomain) => void;
    isNewDomain: boolean;
    state: CellStateType;
}

export const SelectedDomainItem: FC<ISelectedDomainItem> = ({ entity, onDeleteDomain, isNewDomain, state }) => {
    const { domain = "", favicon = "" } = entity;
    return (
        <DomainRowContainer isNewDomain={isNewDomain}>
            <DomainItemContainer state={state}>
                <DomainItem>
                    <CoreWebsiteCell
                        icon={favicon}
                        domain={domain}
                        externalLink={`http://${domain}`}
                        trackExternalLink={() =>
                            allTrackers.trackEvent("external link", "click", `marketBuilder/your list`)
                        }
                        hideTrackButton={true}
                    />
                </DomainItem>
                <StyledIconButton
                    type="flat"
                    iconName="delete"
                    onClick={onDeleteDomain}
                />
            </DomainItemContainer>
        </DomainRowContainer>
    );
};
